import React, { ReactElement, ReactNode } from 'react'

interface TariffConditionDownloadProps {
  children?: ReactNode;
  productType: string;
}

const Component = ({ children, productType }: TariffConditionDownloadProps): ReactElement => {
  const files = [
    {
      title: 'Widerrufsformular',
      url: '/anlage/Widerrufsformular.pdf',
      ctg: true
    },
    {
      title: 'Allgemeine Geschäftsbedingungen',
      url: '/anlage/AllgemeineGeschäftsbedingungen.pdf',
      ctg: true
    },
    {
      title: 'Stromkennzeichnung',
      url: '/anlage/Stromkennzeichnung.pdf',
      ctg: false
    },
    {
      title: 'Tarifinformationen',
      url: '/anlage/Tarifinformation.pdf',
      ctg: true
    },
    {
      title: 'SEPA-Lastschriftmandat',
      url: '/anlage/SEPALastschriftmandat.pdf',
      ctg: true
    }
  ]

  const filteredFiles = productType === 'Cloud to go' ? files.filter(file => file.ctg) : files

  const handleClick = (url: string) => {
    // Validate the URL before redirecting
    if (url.startsWith('/anlage/')) {
      window.open(url, '_blank')
    } else {
      console.error('Invalid URL')
    }
  }

  return (
    <div>
      <h5 className="h5">Dokumente zum Tarif</h5>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {filteredFiles.map((file, index) => (
        <div key={index} className="text-center text-black">
            <qz-link href={file.url} button="" outline=""
                     type="link_btn" target="_blank"
                     onClick={(e: any) => {
                       e.preventDefault()
                       handleClick(file.url)
                     }}>
              <qz-icon class="mr-3" name="arrow-down"/>
              <div>{file.title}</div>
            </qz-link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Component
